import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useModal_deprecated } from 'hooks'
import HomeRebrand from './HomeRebrand'

const RebrandAlert = ({ handleClose = () => {} }) => {
  const [alreadySeen, setAlreadySeen] = useState(false)
  const closeCallBack = () => {
    setAlreadySeen(false)
    handleClose()
  }
  const alertModal = useModal_deprecated(closeCallBack)
  const alorebrandAnnoucment =
    window?.REACT_ENV_VARIABLES?.ALO_REBRAND_ANNOUCEMENT
  const showRebrandModal =
    !alreadySeen && alorebrandAnnoucment.toLowerCase() === 'true'
  useEffect(() => {
    if (!alreadySeen) {
      alertModal.open()
    }
  }, [alreadySeen])

  return (
    <Fragment>
      {showRebrandModal && <HomeRebrand useModal={alertModal} />}
    </Fragment>
  )
}

RebrandAlert.propTypes = {
  data: PropTypes.object
}

export default RebrandAlert
